/* MiniSprays mobile shopping. Uses live Liquid variant data and the theme's native cart form. */
(() => {
  'use strict';
  if (window.msMobileShopping) return;
  const configEl = document.getElementById('ms-mobile-shopping-config');
  const dialog = document.getElementById('ms-mobile-quickbuy');
  if (!configEl || !dialog || typeof dialog.showModal !== 'function') return;
  const config = JSON.parse(configEl.textContent);
  const mobile = window.matchMedia('(max-width: 767px)');
  const content = dialog.querySelector('[data-ms-content]');
  const status = dialog.querySelector('[data-ms-status]');
  const fullLink = dialog.querySelector('[data-ms-full-link]');
  const formTemplate = document.getElementById('ms-mobile-buy-form');
  let controller = null;
  let requestSerial = 0;
  let opener = null;
  let cartOpener = null;
  let pageLock = null;
  let submitting = false;

  function plain(value) {
    const template = document.createElement('template');
    template.innerHTML = String(value == null ? '' : value);
    return template.content.textContent.trim();
  }
  function productUrl(href) {
    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return null;
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  function lockPage() {
    pageLock = { y: window.scrollY, top: document.body.style.top };
    document.body.style.top = `-${pageLock.y}px`;
    document.body.classList.add('ms-mobile-locked');
    document.documentElement.classList.add('ms-mobile-locked-root');
  }
  function unlockPage() {
    if (!pageLock) return;
    const saved = pageLock;
    pageLock = null;
    document.body.classList.remove('ms-mobile-locked');
    document.documentElement.classList.remove('ms-mobile-locked-root');
    document.body.style.top = saved.top;
    const behavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, saved.y);
    document.documentElement.style.scrollBehavior = behavior;
  }
  function closePanel(restoreFocus = true) {
    requestSerial += 1;
    if (controller) controller.abort();
    controller = null;
    if (dialog.open) dialog.close();
    unlockPage();
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (restoreFocus && opener.isConnected) opener.focus({ preventScroll: true });
    }
  }
  function showFallback() {
    content.replaceChildren();
    status.hidden = false;
    status.textContent = config.selectionHelp;
    status.removeAttribute('aria-busy');
  }
  function showProduct(data, url) {
    const variants = Array.isArray(data.variants) ? data.variants : [];
    if (!data.eligible || !variants.length || !customElements.get('product-form')) {
      showFallback();
      return;
    }
    // Build in an inert template before upgrading the native product-form component.
    const fragment = formTemplate.content.cloneNode(true);
    const nativeForm = fragment.querySelector('product-form');
    const form = fragment.querySelector('form');
    const idInput = form.querySelector('[name="id"]');
    const fieldset = fragment.querySelector('fieldset');
    const options = fragment.querySelector('[data-ms-options]');
    const image = fragment.querySelector('[data-ms-image]');
    const title = fragment.querySelector('[data-ms-title]');
    const summary = fragment.querySelector('[data-ms-selected]');
    const button = form.querySelector('[name="add"]');
    title.textContent = data.title;
    if (data.image) { image.src = data.image; image.alt = data.title; } else { image.hidden = true; }
    form.action = config.cartAddUrl;
    form.dataset.productId = data.id;
    const explicit = url.searchParams.get('variant');
    let selected = variants.find(v => String(v.id) === explicit && v.available)
      || variants.find(v => v.size === 5 && v.available)
      || variants.find(v => v.available)
      || null;
    const choose = (variant) => {
      selected = variant;
      idInput.value = selected ? String(selected.id) : '';
      summary.textContent = selected ? `${selected.label} · ${selected.price}` : config.soldOut;
      button.disabled = !selected || !selected.available;
      button.textContent = button.disabled ? config.soldOut : config.addToCart;
      fullLink.href = url.href;
      if (selected) {
        const selectedUrl = new URL(url.href);
        selectedUrl.searchParams.set('variant', String(selected.id));
        fullLink.href = selectedUrl.href;
      }
    };
    variants.forEach(variant => {
      const label = document.createElement('label');
      label.className = 'ms-mobile-size';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'ms-mobile-size';
      input.value = String(variant.id);
      input.disabled = !variant.available;
      input.checked = !!selected && String(selected.id) === String(variant.id);
      const face = document.createElement('span');
      face.className = 'ms-mobile-size__face';
      const name = document.createElement('strong');
      name.textContent = variant.label;
      const price = document.createElement('span');
      price.textContent = variant.price;
      face.append(name, price);
      if (!variant.available) {
        const unavailable = document.createElement('small');
        unavailable.textContent = config.soldOut;
        face.append(unavailable);
      }
      label.append(input, face);
      options.append(label);
      input.addEventListener('change', () => { if (input.checked && variant.available && !submitting) choose(variant); });
    });
    choose(selected);
    form.addEventListener('submit', event => {
      if (submitting || !selected || !selected.available || idInput.value !== String(selected.id)) {
        event.preventDefault(); event.stopImmediatePropagation(); return;
      }
      submitting = true;
      fieldset.disabled = true;
    }, true);
    const unlockForm = () => { submitting = false; fieldset.disabled = false; };
    nativeForm.addEventListener('on:cart:error', () => {
      unlockForm();
      const error = nativeForm.querySelector('.js-form-error');
      if (!error.textContent.trim()) { error.textContent = config.cartError; error.hidden = false; }
    });
    nativeForm.addEventListener('on:cart:add', () => { unlockForm(); closePanel(false); });
    status.hidden = true;
    status.removeAttribute('aria-busy');
    content.replaceChildren(fragment);
  }
  async function openPanel(trigger) {
    if (submitting || document.body.classList.contains('fixed')) return;
    const url = productUrl(trigger.href);
    if (!url) return;
    if (controller) controller.abort();
    const serial = ++requestSerial;
    controller = new AbortController();
    const signal = controller.signal;
    opener = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    content.replaceChildren();
    fullLink.href = url.href;
    status.hidden = false;
    status.textContent = `${config.chooseSize}…`;
    status.setAttribute('aria-busy', 'true');
    if (!dialog.open) { lockPage(); dialog.showModal(); }
    const fetchUrl = new URL(url.href);
    fetchUrl.searchParams.delete('section_id');
    fetchUrl.searchParams.delete('sections');
    fetchUrl.searchParams.set('section_id', 'ms-mobile-product-data');
    const timeout = setTimeout(() => controller && serial === requestSerial && controller.abort(), 12000);
    try {
      const response = await fetch(fetchUrl.href, { credentials: 'same-origin', signal });
      if (!response.ok) throw new Error('Product unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const dataNode = html.querySelector('[data-ms-mobile-product]');
      if (!dataNode) throw new Error('Product data missing');
      const data = JSON.parse(dataNode.textContent);
      if (serial !== requestSerial || !dialog.open) return;
      showProduct(data, url);
    } catch (error) {
      if (serial === requestSerial && dialog.open) showFallback();
    } finally {
      clearTimeout(timeout);
      if (serial === requestSerial) controller = null;
    }
  }

  function enhanceCards(root = document) {
    if (!mobile.matches) return;
    const cards = [...(root.matches && root.matches('product-block') ? [root] : []), ...root.querySelectorAll('product-block')];
    cards.forEach(card => {
      if (card.dataset.msMobileReady || card.matches('.product-block--compact')
        || card.closest('cart-drawer, quickbuy-container, .quickbuy-container, modal-dialog, #ms-mobile-quickbuy')) return;
      const link = card.querySelector('a.product-link[href*="/products/"]');
      if (!link) return;
      const outer = card.closest('.ms-discover-card');
      let trigger = outer && outer.querySelector('.ms-discover-quickbuy');
      if (!trigger) {
        const mount = card.querySelector('.product-block__detail') || card.querySelector('.block-inner-inner');
        if (!mount) return;
        trigger = document.createElement('a');
        trigger.href = link.href;
        trigger.textContent = config.chooseSize;
        trigger.className = 'ms-mobile-choose btn btn--primary';
        mount.append(trigger);
      }
      trigger.dataset.msMobileBuy = 'true';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'ms-mobile-quickbuy');
      trigger.setAttribute('aria-expanded', 'false');
      card.dataset.msMobileReady = 'true';
    });
  }
  function enhanceSticky(root = document) {
    const bars = [...(root.matches && root.matches('sticky-atc') ? [root] : []), ...root.querySelectorAll('sticky-atc')];
    bars.forEach(bar => {
      if (bar.dataset.msPriceReady) return;
      const section = bar.closest('.section-main-product');
      const main = section && section.querySelector('.js-product');
      const picker = main && main.querySelector('variant-picker');
      const json = picker && picker.querySelector('[type="application/json"]');
      const form = main && main.querySelector('form.js-product-form');
      const container = bar.querySelector('.sticky-atc__details__variant');
      if (!form || !json || !container) return;
      let data;
      try { data = JSON.parse(json.textContent); } catch { return; }
      const price = document.createElement('span');
      price.className = 'ms-sticky-selected-price';
      price.setAttribute('aria-live', 'polite');
      price.setAttribute('aria-atomic', 'true');
      container.append(price);
      bar.dataset.msPriceReady = 'true';
      const sync = () => {
        if (!mobile.matches) return;
        const mainId = form.querySelector('[name="id"]');
        const variant = data.variants.find(v => String(v.id) === (mainId && mainId.value));
        const formatted = variant && data.formatted && data.formatted[variant.id];
        const text = formatted ? plain(formatted.price) : '';
        if (price.textContent !== text) price.textContent = text;
        price.hidden = !text;
        const title = bar.querySelector('.sticky-atc__details__variant__title');
        if (title && variant && title.textContent.trim() !== variant.title) title.textContent = variant.title;
        const hiddenId = bar.querySelector('form [name="id"]');
        if (hiddenId && mainId) hiddenId.value = mainId.value;
        const button = bar.querySelector('button[name="add"]');
        if (button && !button.classList.contains('is-loading')) button.disabled = !!variant && !variant.available;
      };
      const schedule = () => { sync(); requestAnimationFrame(sync); };
      section.addEventListener('on:variant:change', event => {
        if (!event.detail.form || event.detail.form === form) schedule();
      });
      main.addEventListener('change', schedule);
      const variantId = form.querySelector('[name="id"]');
      if (variantId) new MutationObserver(schedule).observe(variantId, { attributes: true, attributeFilter: ['value'] });
      const stickyForm = bar.querySelector('form');
      if (stickyForm) stickyForm.addEventListener('submit', sync, true);
      mobile.addEventListener('change', schedule);
      sync();
    });
  }
  document.addEventListener('click', event => {
    if (!mobile.matches || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || (event.button && event.button !== 0)) return;
    const trigger = event.target.closest('a[data-ms-mobile-buy], product-block a.quickbuy-toggle');
    if (!trigger || !productUrl(trigger.href)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    openPanel(trigger);
  }, true);
  dialog.querySelector('[data-ms-close]').addEventListener('click', () => closePanel());
  dialog.addEventListener('cancel', event => { event.preventDefault(); closePanel(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closePanel(); } });
  // Hand page scroll ownership back before the native cart drawer takes over.
  document.addEventListener('on:cart-drawer:before-open', () => { if (dialog.open) { cartOpener = opener; closePanel(false); } });
  document.addEventListener('on:cart-drawer:after-close', () => { if (cartOpener && cartOpener.isConnected) cartOpener.focus({ preventScroll: true }); cartOpener = null; });
  mobile.addEventListener('change', () => { if (!mobile.matches) closePanel(false); else enhanceCards(); });
  document.addEventListener('shopify:section:load', event => { enhanceCards(event.target); enhanceSticky(event.target); });
  enhanceCards(); enhanceSticky();
  const mainContent = document.querySelector('main');
  if (mainContent) new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches('product-block, sticky-atc') || node.querySelector('product-block, sticky-atc')) {
        enhanceCards(node); enhanceSticky(node);
      }
    }));
  }).observe(mainContent, { childList: true, subtree: true });
  window.msMobileShopping = { version: '1.0.0', close: closePanel };
})();
